(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Logo: dibuja el guiño (G) y la pupila (O) ---------- */
  function initLogos() {
    var svgs = document.querySelectorAll('.wf-logo-svg:not([data-wf-ready])');
    svgs.forEach(function (svg) {
      svg.setAttribute('data-wf-ready', '1');
      var gEl = svg.querySelector('.wf-logo-g');
      var oEl = svg.querySelector('.wf-logo-o');
      if (!gEl || !oEl) return;
      try {
        var gb = gEl.getBBox();
        var ob = oEl.getBBox();
        var ns = 'http://www.w3.org/2000/svg';

        var pupil = document.createElementNS(ns, 'circle');
        pupil.setAttribute('class', 'wf-logo-pupil');
        pupil.setAttribute('cx', (ob.x + ob.width * 0.58).toFixed(1));
        pupil.setAttribute('cy', (ob.y + ob.height * 0.56).toFixed(1));
        pupil.setAttribute('r', (Math.min(ob.width, ob.height) * 0.14).toFixed(1));
        svg.appendChild(pupil);

        var wink = document.createElementNS(ns, 'path');
        var x1 = gb.x + gb.width * 0.66, y1 = gb.y + gb.height * 0.14;
        var x2 = gb.x + gb.width * 0.98, y2 = gb.y + gb.height * 0.02;
        var mx = (x1 + x2) / 2, my = Math.min(y1, y2) - gb.height * 0.05;
        wink.setAttribute('class', 'wf-logo-wink');
        wink.setAttribute('d', 'M ' + x1.toFixed(1) + ' ' + y1.toFixed(1) + ' Q ' + mx.toFixed(1) + ' ' + my.toFixed(1) + ' ' + x2.toFixed(1) + ' ' + y2.toFixed(1));
        svg.appendChild(wink);
      } catch (e) { /* getBBox no disponible (oculto) */ }
    });
  }

  /* ---------- Reveal on scroll ---------- */
  function showReveal(el) {
    el.classList.add('wf-visible');
    el.style.opacity = '1';
    el.style.transform = 'none';
  }

  function initReveal() {
    var els = document.querySelectorAll('.wf-reveal');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(showReveal);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          showReveal(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el, i) {
      el.style.setProperty('--wf-i', i % 6);
      io.observe(el);
    });
  }

  /* ---------- Header sticky blur ---------- */
  function initHeader() {
    var wrap = document.querySelector('.wf-header-wrap');
    if (!wrap) return;
    function onScroll() {
      wrap.classList.toggle('wf-scrolled', window.scrollY > 8);
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    var burger = document.querySelector('.wf-header__burger');
    var menu = document.querySelector('.wf-mobile-menu');
    var close = document.querySelector('.wf-mobile-menu__close');
    if (burger && menu) {
      burger.addEventListener('click', function () { menu.classList.add('wf-open'); document.body.style.overflow = 'hidden'; });
    }
    if (close && menu) {
      close.addEventListener('click', function () { menu.classList.remove('wf-open'); document.body.style.overflow = ''; });
    }
    if (menu) {
      menu.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', function () { menu.classList.remove('wf-open'); document.body.style.overflow = ''; });
      });
    }
  }

  /* ---------- FAQ accordion ---------- */
  function initFaq() {
    document.querySelectorAll('.wf-faq-item__q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.wf-faq-item');
        var answer = item.querySelector('.wf-faq-item__a');
        var isOpen = item.classList.contains('wf-open');
        item.closest('.wf-faq__list').querySelectorAll('.wf-faq-item.wf-open').forEach(function (openItem) {
          if (openItem !== item) {
            openItem.classList.remove('wf-open');
            openItem.querySelector('.wf-faq-item__a').style.maxHeight = null;
          }
        });
        if (isOpen) {
          item.classList.remove('wf-open');
          answer.style.maxHeight = null;
        } else {
          item.classList.add('wf-open');
          answer.style.maxHeight = answer.scrollHeight + 'px';
        }
      });
    });
  }

  /* ---------- Selectores de cantidad ---------- */
  function initQty() {
    document.querySelectorAll('.wf-qty').forEach(function (qty) {
      var input = qty.querySelector('input');
      qty.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var val = parseInt(input.value, 10) || 1;
          val = btn.dataset.step === 'up' ? val + 1 : Math.max(1, val - 1);
          input.value = val;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---------- Galería de producto ---------- */
  function initGallery() {
    document.querySelectorAll('[data-wf-gallery]').forEach(function (gallery) {
      var main = gallery.querySelector('.wf-gallery__main img');
      var thumbs = gallery.querySelectorAll('.wf-gallery__thumbs button');
      var form = gallery.closest('.wf-producto__grid, [data-wf-gallery-scope]');
      form = form ? form.querySelector('[data-wf-product-form]') : null;
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          if (!main) return;
          main.src = thumb.dataset.full;
          main.srcset = '';
          thumbs.forEach(function (t) { t.classList.remove('wf-active'); });
          thumb.classList.add('wf-active');
          if (thumb.dataset.variantId && form && form.wfSelectVariantById) {
            form.wfSelectVariantById(thumb.dataset.variantId);
          }
        });
      });
    });
  }

  /* ---------- Selector de variantes ---------- */
  function initVariants() {
    document.querySelectorAll('[data-wf-product-form]').forEach(function (form) {
      var variantsData = form.querySelector('[data-wf-variants]');
      if (!variantsData) return;
      var variants;
      try { variants = JSON.parse(variantsData.textContent); } catch (e) { return; }
      var scope = form.closest('.wf-producto__buy, .wf-oferta__card') || form;
      var idInput = form.querySelector('input[name="id"]');
      var priceEl = scope.querySelector('[data-wf-price]');
      var compareEl = scope.querySelector('[data-wf-compare-price]');
      var submitBtn = form.querySelector('[data-wf-submit]');
      var stockEl = form.querySelector('[data-wf-stock]');

      function money(cents) {
        return (cents / 100).toLocaleString(document.documentElement.lang || 'es-ES', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' });
      }

      function currentSelection() {
        var sel = {};
        form.querySelectorAll('[data-wf-option]').forEach(function (group) {
          var active = group.querySelector('.wf-option-pill.wf-active');
          if (active) sel[group.dataset.wfOption] = active.dataset.value;
        });
        return sel;
      }

      function findVariant(sel) {
        return variants.find(function (v) {
          return v.options.every(function (val, i) { return val === sel[i + 1]; });
        });
      }

      function update() {
        var sel = currentSelection();
        var selArr = { 1: sel[1], 2: sel[2], 3: sel[3] };
        var variant = findVariant(selArr);
        if (!variant) return;
        idInput.value = variant.id;
        if (priceEl) priceEl.textContent = money(variant.price);
        if (compareEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compareEl.textContent = money(variant.compare_at_price);
            compareEl.style.display = '';
          } else {
            compareEl.style.display = 'none';
          }
        }
        if (submitBtn) {
          submitBtn.disabled = !variant.available;
          submitBtn.textContent = variant.available ? submitBtn.dataset.textAvailable : submitBtn.dataset.textSoldOut;
        }
        if (stockEl) {
          stockEl.textContent = variant.available ? stockEl.dataset.textIn : stockEl.dataset.textOut;
          stockEl.className = 'wf-producto__stock ' + (variant.available ? 'wf-producto__stock--in' : 'wf-producto__stock--out');
        }
      }

      form.querySelectorAll('.wf-option-pill').forEach(function (pill) {
        pill.addEventListener('click', function () {
          var group = pill.closest('[data-wf-option]');
          group.querySelectorAll('.wf-option-pill').forEach(function (p) { p.classList.remove('wf-active'); });
          pill.classList.add('wf-active');
          update();
        });
      });

      form.wfSelectVariantById = function (variantId) {
        var variant = variants.find(function (v) { return String(v.id) === String(variantId); });
        if (!variant) return;
        form.querySelectorAll('[data-wf-option]').forEach(function (group, i) {
          var wanted = variant.options[i];
          group.querySelectorAll('.wf-option-pill').forEach(function (p) {
            p.classList.toggle('wf-active', p.dataset.value === wanted);
          });
        });
        update();
      };
    });
  }

  /* ---------- Añadir al carrito (AJAX) + refresco del cajón nativo de Dawn ---------- */
  function initAddToCart() {
    document.querySelectorAll('[data-wf-product-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[data-wf-submit]');
        var qtyInput = form.querySelector('.wf-qty input');
        var formData = new FormData(form);
        if (qtyInput) formData.set('quantity', qtyInput.value || 1);
        formData.append('sections', 'cart-drawer,cart-icon-bubble');
        formData.append('sections_url', window.location.pathname);
        if (btn) { btn.disabled = true; btn.dataset.originalText = btn.textContent; btn.textContent = '...'; }

        fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: formData
        })
          .then(function (r) { return r.json(); })
          .then(function (response) {
            if (response.status) { window.location.href = '/cart'; return; }
            var drawer = document.querySelector('cart-drawer');
            if (drawer && response.sections) {
              drawer.classList.remove('is-empty');
              drawer.renderContents(response);
            } else {
              window.location.href = '/cart';
            }
          })
          .catch(function () { window.location.href = '/cart'; })
          .finally(function () {
            if (btn) { btn.disabled = false; btn.textContent = btn.dataset.originalText; }
          });
      });
    });
  }

  /* ---------- CTA sticky móvil ---------- */
  function initStickyCta() {
    var cta = document.querySelector('.wf-sticky-cta');
    var hero = document.querySelector('.wf-hero');
    if (!cta || !hero) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        cta.classList.toggle('wf-show', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    io.observe(hero);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initLogos();
    initReveal();
    initHeader();
    initFaq();
    initQty();
    initGallery();
    initVariants();
    initAddToCart();
    initStickyCta();
  });

  document.addEventListener('shopify:section:load', function () {
    initLogos();
    initReveal();
  });
})();
